import styled from "styled-components"
import Container from "@mui/material/Container"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ImagePost = styled(CustomImage)`
  width: 100%;
  height: 100%;
`
